module.exports = __webpack_public_path__ + "img/logo-mini.99d1b8e2.svg";